import * as _ from 'lodash'
import axios from 'axios'


class Param {

  /**
   * Recupera alguns parametros.
   *
   * @returns {Promise} .
   */
  getParm() {
    return axios.get('/v1/getParams');
  }

  getGeneralParameter(req){
    return axios.post('/v2/getGeneralParameter', req).then(res => res.data);
  }

}

const instance = new Param();
export default instance;



// WEBPACK FOOTER //
// ./src/services/param.js